import React from 'react';
import { Router, Route, browserHistory, IndexRoute } from 'react-router';
import { syncHistoryWithStore } from 'react-router-redux';
import createStore from './Redux';
import { init_pubhub_projects, getCanonicalFromConfig, eliminateUtmFromUrl } from "./utility/url";

// pages
import Site from './pages/Site';
import Search from './pages/Search';
import DocDetail from "./pages/Docs/Detail";
import Login from './pages/Login';
import Logout from './pages/Logout';
import PubHub from './pages/PubHub';
import Page404 from './pages/404';
import Page403 from './pages/403';

import DirectDownload from './pages/DirectDownload';

const store = createStore();
const history = syncHistoryWithStore(browserHistory, store);

// utility
import { setLanguage, QueryString, update_status_code } from "./utility/browser";

import {
    url_replace,
    normalizeURL,
    apply_routing_policy,
    apply_access_control,
    exception_404,
    pubhub_access_control
} from "./utility/url";

import {
    initSocialLogin
} from "./utility/socialLogin"


const default_page_setting = {
    "header": "standard",
    "footer": "standard"
};


const reloadPage = () => window.location.reload()

const SiteRoute = (store) => {
    const onLoadApp = (nextState, replace, callback) => {

        // whole site protection
        // just for staging

        if (window["SITE_PROTECTED"] && window["DEVNET-STAGING"] !== true) {
            setTimeout(() => {
                document.write("<h1>Accessible only in Cisco Network</h1>")
            }, 0);
            return false
        }

        //init Social Login
        initSocialLogin();

        //set language
        if (QueryString["locale"]) {
            setLanguage(QueryString["locale"])
        }

        // start routing
        route(nextState, replace, callback)
    };


    const onURLChange = (prevState, nextState, replace, callback) => {

        //don't update for pubhub docs when it is scrolling
        if (nextState.location.pathname == prevState.location.pathname) {
            if (prevState.location.pathname.startsWith("/pubhub/docs/") || prevState.location.pathname.startsWith("/docs/")) {
                const url = window.location.href;
                // remove "/try-it-out" from  /docs/sandbox/#!getting-started/try-it-out
                // const hashes = location.hash.split("/");
                // if (hashes.length >= 2) {
                //     url = location.origin + location.pathname + hashes[0];
                //     // url = location.href.slice(0, location.href.indexOf(hashes[1]) - 1)
                // }

                updateCanonicalTag(url);
                return;
            }
        }

        route(nextState, replace, callback, prevState)

    };

    const route = (nextState, replace, callback, prevState) => {

        if (nextState.location.pathname == "/") {
            updateCanonicalTag(nextState.location.pathname);

            // AnalyticsSDK.setMetaDataTags(CONFIG["PAGE_TITLE"], "");

            update_status_code(200);

            //trigger
            callback();

            return
        } else {
            //remove warnings 
            window.postMessage({
                "source": "@dn.site.warning",
                "data": null
            }, location.origin);
        }

        // update replace function to support `http` route
        const _replace = url_replace(replace);

        // normalize url
        let { changed, pathname, url } = normalizeURL(nextState);

        // if url is changed, redirect
        if (changed) {
            replace(url);
        }

        // access control
        if (!apply_access_control(nextState, replace, pathname, prevState)) {
            return true;
        }

        // check routing policy
        let { urlchanged, redirectHTTP, newURL } = apply_routing_policy(nextState, _replace, pathname);

        if (!redirectHTTP) {

            updateCanonicalTag(newURL);

            AnalyticsSDK.setMetaDataTags(CONFIG["PAGE_TITLE"]);

            update_status_code(200);

            //trigger
            callback();
        }
    };
    const PubHub_URL_Mapping_routes = [];

    init_pubhub_projects();

    Object.keys(window["PUBHUB_PATH_LIST"]).forEach((url) => {

        const obj = window["PUBHUB_PATH_LIST"][url];
        //get ui setting
        const setting = obj["setting"] ? JSON.parse(obj["setting"]) : default_page_setting;
        //get routing setting
        const routing_setting = JSON.parse(obj["routing_setting"]);
        //see if this project include sub pages, then add * in the routing path
        const _url = routing_setting["includeSubPages"] ? url + "*" : url;

        if (obj["type"] === "docs") {
            PubHub_URL_Mapping_routes.push({
                url: url,
                path: _url,
                component: DocDetail,
                uri: obj["uri"],
                phlocation: obj["location"],
                setting: setting,
                access_control: obj["access_control"] || "public",
                config: obj,
                onEnter: pubhub_access_control
            })
        }

        if (obj["type"] === "site") {
            PubHub_URL_Mapping_routes.push({
                url: url,
                path: _url,
                component: Site,
                uri: obj["uri"],
                phlocation: obj["location"],
                setting: setting,
                access_control: obj["access_control"] || "public",
                config: obj,
                onEnter: pubhub_access_control
            })
        }
    });

    // for preview home page pn staging
    if (window["PUBHUB_PATH_LIST"]["/site/index/"]) {
        const index = window["PUBHUB_PATH_LIST"]["/site/index/"];
        PubHub_URL_Mapping_routes.push({
            url: "/",
            path: "/",
            component: Site,
            config: index,
            uri: index["uri"],
            phlocation: index["location"],
            setting: JSON.parse(index["setting"])
        })
    }


    const updateCanonicalTag = (url) => {
        let _url = url ? url : window.location.href;

        if (!_url.startsWith("http")) {
            _url = location.origin + _url;
        }

        _url = eliminateUtmFromUrl(_url);
        _url = handleCanonicalHash(_url);
        _url = getCanonicalFromConfig(_url);
        _url = temporary_build_prime_infrastructure_canonical(_url);
        
        document.querySelector("[rel='canonical']").setAttribute("href", _url);
    };

    PubHub_URL_Mapping_routes.sort((a, b) => a.url < b.url ? 1 : -1);

    return (
        <Router history={history}>
            <Router onChange={onURLChange} onEnter={onLoadApp}>

                <Route path="/search/*" component={Search} />

                <Route path="/search(/)*" component={Search} />

                <Route childRoutes={PubHub_URL_Mapping_routes} />

                <Route path="/site/devnet/search-results/*" component={Search} />

                {PubHub_URL_Mapping_routes.length === 0 && (
                    <Route path={"/site/"}>
                        <Route path="/site/:projectName(/:pageName/)*" component={Site}/>
                    </Route>
                )}

                <Router path="/fileMedia/download/:fileMediaID" component={DirectDownload} />

                {/* <Router path={"/events*"} onEnter={reloadPage}/> */}
                <Router path={"/meraki*"} onEnter={reloadPage}/>
                <Router path={"/feedback*"} onEnter={reloadPage}/>
                <Router path={"/codeexchange*"} onEnter={reloadPage}/>
                <Router path={"/api-insights-demo*"} onEnter={reloadPage}/>
                <Router path={"/api-insights-cisco*"} onEnter={reloadPage}/>

                {PubHub_URL_Mapping_routes.length === 0 && (
                    <Route path={"/docs/"}>
                        <Route path="/docs/:projectName(/)*" component={DocDetail}/>
                    </Route>
                )}

                <Route path="/pubhub/:projectType/:projectID/:projectStatus/*" component={PubHub} />

                <Route path="/login(/)*" component={Login} />
                <Route path="/SSO/login(/)*" component={Login} />

                <Route path="/logout(/)*" component={Logout} />
                <Route path="/SSO/logout(/)*" component={Logout} />

                <Route path="/403/" component={Page403} />

                <Route path="/" component={Site} uri="index" />

                <Router path="*" onEnter={exception_404} component={Page404}/>
            </Router>
        </Router>
    )
};

// will be removed at someday in 2022, 
// /site/prime-infrastructure/documents/api-reference/rest-api-v3-1/balabala will be changed into 
// /site/prime-infrastructure/documents/api-reference/latest/balabala
function temporary_build_prime_infrastructure_canonical(url) {
    if (!url.includes("/site/prime-infrastructure/documents/api-reference/")) return url;

    return url.replace(/\/site\/prime-infrastructure\/documents\/api-reference\/.*?\//, 
        "/site/prime-infrastructure/documents/api-reference/latest/");
}

function handleCanonicalHash(url) {
    const urls = url.split('#');
    if (urls.length <= 1) {
        return url;
    }
    const hashes = urls[1].split("/");
    return `${urls[0]}#${hashes[0]}`;
}

export default SiteRoute;
